module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "address-detail-content",
    style: ({
      'padding-bottom': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '50px'
    })
  }, [(_vm.addressInfo === undefined || _vm.addressInfo.length === 0) ? _c('img', {
    staticClass: "default-empty",
    attrs: {
      "src": "static/img/收货地址空.png"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.newAddressInfo), function(address, index) {
    return _c('div', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "id": index
      }
    }, [_c('div', {
      staticClass: "address-block"
    }, [_c('div', {
      staticClass: "content",
      attrs: {
        "id": 'updateAddress' + index
      }
    }, [_c('div', {
      staticClass: "item"
    }, [_c('i', {
      staticClass: "icon-font emkt-icon-didian place"
    }), _vm._v(" "), _c('div', {
      staticClass: "mod",
      on: {
        "click": function($event) {
          return _vm.updateAddress(address, index)
        }
      }
    }, [_c('div', {
      staticClass: "address",
      staticStyle: {
        "width": "100%"
      }
    }, [(address.province !== '') ? _c('div', [_vm._v("\r\n                  " + _vm._s(address.expressAddress) + "\r\n                ")]) : _c('div', [_vm._v("\r\n                  " + _vm._s(address.expressAddress) + "\r\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "container"
    }, [_vm._v("\r\n                  " + _vm._s(address.consignee) + "  " + _vm._s(address.expressMobile) + "\r\n                ")])])]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          name: 'WeappAddressModify',
          query: {
            address: JSON.stringify(address),
            from: _vm.from
          },
          params: {
            order: _vm.$route.params.order,
            addressType: _vm.$route.params.addressType
          }
        }
      }
    }, [_c('i', {
      staticClass: "icon-font emkt-icon-xiugai modify",
      staticStyle: {
        "color": "#424242"
      }
    })])], 1)]), _vm._v(" "), (address.addressSource === 2 && !address.operator) ? _c('div', [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "appendInfo-layout"
    }, [_c('div', {
      staticClass: "appendInfo-content"
    }, [_c('div', [_vm._v("创建业务员:" + _vm._s(address.creator))]), _c('div', [_vm._v(_vm._s(address.createDT))])])])]) : _vm._e()])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-content"
  }, [_c('router-link', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "to": {
        name: 'WeappAddAddress',
        query: {
          from: _vm.from
        },
        params: {
          order: _vm.$route.params.order,
          addressType: _vm.$route.params.addressType
        }
      }
    }
  }, [_c('div', {
    staticClass: "add-btn research-background-color"
  }, [_c('span', {
    staticClass: "tag"
  }, [_vm._v("+添加地址")])])])], 1), _vm._v(" "), _c('footer-placeholder')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hr', {
    staticStyle: {
      "border": "1px dashed",
      "color": "rgb(239, 239, 244)",
      "width": "100%",
      "float": "left",
      "position": "relative",
      "top": "0px"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c0df518","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_v_2.6/MyAddress/Address.vue
// module id = 1530
// module chunks = 8